import Navbar from "./components/Navbar";
import Intro from "./components/Intro";
import About from "./components/About";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import "./App.css";
import sticks from "./sticks.svg";

function App() {
    return (
        <>
            <div className="outer">
                <div className="bg_oval below"></div>
                <div className="container top">
                    <header>
                        <Navbar />
                    </header>
                    <div className="upper_container">
                        <div>
                            <Intro />
                            <About />
                        </div>
                        <img src={sticks} className="sticks" alt="logo" />
                    </div>
                    <PrivacyPolicy />
                    <ContactUs />
                    <footer>
                        <Footer />
                    </footer>
                </div>
            </div>
        </>
    );
}

export default App;
